import { Text } from "$components";
import CField from "$forms/CField";
import FileUploader from "$components/FileUploader/FileUploader";
import { useProductFormContext } from "../contexts/ProductFormContext";
import useJStyles from "$hooks/useJStyles";
import useAuth from "$hooks/useAuth";

export const AttachmentsSection = () => {
  const { jclasses } = useJStyles();
  const { isAdmin, isClient } = useAuth();
  const { form, isReferenced, currentCompany } = useProductFormContext();
  const {
    control,
    formState: { errors },
  } = form;

  if (!isReferenced || !currentCompany) {
    return null;
  }

  return (
    <>
      <div className={jclasses.formSectionHead}>
        <Text type="h3">Pièces jointes</Text>
      </div>
      <CField
        control={control}
        disabled={!isAdmin() && !isClient()}
        name="medias"
        error={errors.medias}
      >
        {(props) => (
          <FileUploader
            company={currentCompany}
            type="product"
            {...props}
            isAdmin={isAdmin()}
          />
        )}
      </CField>
    </>
  );
};
